import { render, staticRenderFns } from "./TuitionFeeBasicSetup.vue?vue&type=template&id=708dc51a&scoped=true"
import script from "./TuitionFeeBasicSetup.vue?vue&type=script&lang=js"
export * from "./TuitionFeeBasicSetup.vue?vue&type=script&lang=js"
import style0 from "./TuitionFeeBasicSetup.vue?vue&type=style&index=0&id=708dc51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708dc51a",
  null
  
)

export default component.exports